module.exports = __webpack_public_path__ + "img/about-bg2.f2db4879.png";